import type { ThemeProps as Props } from "models/styles/theme";
import styled, { css } from "styled-components/macro";
import { CssGrid } from "styles/helpers/layout";

interface PageLayoutProps extends Props {
  $hasHeader: boolean;
  $hasSideMenu: boolean;
  $centerContent: boolean;
}

export const StyledPageLayout = styled(CssGrid)<PageLayoutProps>`
  min-height: 100%;
  grid-template-rows: auto 1fr auto;

  > main {
    grid-area: content;
    width: 100%;
    height: 100%;
    padding: ${(props: PageLayoutProps) => (!props.$hasHeader ? "2.5rem" : "0")};
    min-width: 30rem;
    max-width: 74rem;
  }

  > aside {
    grid-area: navbar;
  }

  > header {
    grid-area: header;
  }

  > footer {
    grid-area: footer;
  }

  ${(props: PageLayoutProps) => {
    if (!props.$hasHeader && props.$hasSideMenu) {
      return css`
        grid-template-areas:
          'navbar content'
          'navbar footer';
        grid-template-columns: minmax(300px, auto) 1fr;
        grid-template-rows: 1fr auto;
        justify-content: center;
        justify-items: center;
      `;
    }

    if (props.$hasSideMenu) {
      return css`
        grid-template-areas:
          'header header'
          'navbar content'
          'footer footer';
        grid-template-columns: minmax(300px, auto) 1fr;
      `;
    }

    return css`
      grid-template-areas:
        'header'
        'content'
        'footer';

      > main {
        margin: auto;
        max-width: 80rem;
        width: calc(100vw - 4rem);
      }
    `;
  }}

  &.studentDashboardNoordhoffRedesign {
    background-color: ${(props: PageLayoutProps) => props.theme.palette.neutral._999};
  }

  ${(props: PageLayoutProps) =>
    (props.$centerContent) &&
    css`
    justify-content: center;
    justify-items: center;
  `};
`;
